module.exports = __webpack_public_path__ + "static/media/Patty Gale.ce4f4a80.png";